import { Provider } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useSourceAccounts } from './useSourceAccounts';

export const useCloudProviders = () => {
  const { sourceAccounts } = useSourceAccounts();

  return useMemo(
    () =>
      Array.from(
        (sourceAccounts || []).reduce((acc, account) => {
          const provider = account.sourceAccountAttributes.cloudProvider;
          if (provider !== Provider.ProviderUnspecified) {
            acc.add(provider);
          }
          return acc;
        }, new Set<Provider>())
      ).sort(),
    [sourceAccounts]
  );
};

export const getAllCloudProviders = (isDemoOrDev: boolean) =>
  Object.values(Provider).filter(
    (x) =>
      x !== Provider.ProviderUnspecified &&
      x !== Provider.GoogleWorkspace &&
      (isDemoOrDev || x !== Provider.MongoAtlas)
  );
